import { API_BASE, request } from './core.api';
import type { PropertyStatus } from './properties.api';

export interface PropertyPublicPageDto {
  propertyId: string;
  isConfigured: boolean;
  isActive: boolean;
  publicUrl?: string | null;
  expiresAtUtc?: string | null;
  updatedAt?: string | null;
}

export interface SavePropertyPublicPageRequest {
  isActive: boolean;
  expiresAtUtc?: string | null;
}

export interface PublicPropertyGalleryPhotoDto {
  id: string;
  fileName: string;
  downloadUrl: string;
}

export interface PropertyPublicPagePublicDto {
  address: string;
  type: string;
  status: PropertyStatus;
  description?: string | null;
  landlordDisplayName: string;
  expiresAtUtc?: string | null;
  galleryPhotos: PublicPropertyGalleryPhotoDto[];
}

export const propertyPublicPagesApi = {
  getByProperty: (propertyId: string) =>
    request<PropertyPublicPageDto>(`/properties/${propertyId}/public-page`),

  save: (propertyId: string, data: SavePropertyPublicPageRequest) =>
    request<PropertyPublicPageDto>(`/properties/${propertyId}/public-page`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  getByToken: async (token: string): Promise<PropertyPublicPagePublicDto | null> => {
    const response = await fetch(`${API_BASE}/public/properties/${encodeURIComponent(token)}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  apply: (token: string) => request(`/property-public-pages/${encodeURIComponent(token)}/applications`, {
    method: 'POST',
    body: JSON.stringify({}),
  }),
};
